

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';  // <----
let firebaseApp;
SetupFirebase();

/**
* Firebase Initialization Function
* This must be called before any firebase query
*/
function SetupFirebase() {
    const firebaseConfig = {
        apiKey: "AIzaSyDST3bZwwi-FGCv_GhtdHsuIAnSRK4e1Yk",
        authDomain: "kvh-stock-management.firebaseapp.com",
        projectId: "kvh-stock-management",
        storageBucket: "kvh-stock-management.appspot.com",
        messagingSenderId: "379339986207",
        appId: "1:379339986207:web:56afd4ba31347513490c2a",
        measurementId: "G-D92Z4P8YLZ"
    };
    // Initialize Firebase
    firebaseApp = firebase.initializeApp(firebaseConfig);
}

export default firebaseApp;
